module.exports = __webpack_public_path__ + "static/media/sexo.6bf3a6c9.svg";